<template>
<div class="">
    <!-- Page Banner -->
    <section class="innersec">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-12">
                    <div class="toptitle text-center">
                        <h2>{{ pagetitle }}</h2>
                        <nav>
                            <ol class="breadcrumb bg-transparent p-0 justify-content-center font-weight-bold">
                                <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                                <li class="breadcrumb-item active">{{ pagetitle }}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Page Banner -->
</div>
</template>

<script>
export default {
    props: {
       pagetitle: String
    },
    name: 'PageBreadcrumb'
}
</script>


<style>

</style>